import { GET_GUEST_TYPE } from './../constants/actionTypes'

const guestType = (store = {}, action = {}) => {
  if(action.type === GET_GUEST_TYPE){
    return action.data.data
  }
  else{
    return store
  }
}

export default guestType
